import {combineReducers} from 'redux';
import {actionize} from 'utils';

let types = {
  SET_SPLIT: null
};
types = actionize(types, (action) => `schooladmin/billingFinancialSplit/${action}`);

const initialState = {};

const setSplit = (contactId, schoolYearId, billingContactId) => (dispatch) => {
  dispatch({
    type: types.SET_SPLIT,
    contactId,
    schoolYearId,
    billingContactId
  });
};

const contacts = (state = initialState, action) => {
  switch(action.type){
    case types.SET_SPLIT:
      if (state[action.contactId]) {
        return {
          ...state,
          [action.contactId]: {
            ...state[action.contactId],
            [action.schoolYearId]: action.billingContactId
          }
        }
      } else {
        return {
          ...state,
          [action.contactId]: {
            [action.schoolYearId]: action.billingContactId
          }
        }
      }
  }

  return state;
};

export const actions = {
  setSplit
};

const reducer = combineReducers({
  contacts
});

export const entity = {
  name: 'billingFinancialSplit',
  actions,
  reducer
};
